/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function _addMeToCartSingle(e, el) {
e = e || window.event;
e.preventDefault();

let formData = {
'items': [
{
'id': el.dataset.variant_id,
'quantity': 1
}
]
};

fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(formData)
})
.then((resp) => {
return resp.json();
})
.then((data) => {
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
bubbles: true
}));
})
.catch((err) => {
console.error('Error: ' + err);
})
}



// Global variable to store the selected variant ID.
var selectedVariantId = null;

document.addEventListener('DOMContentLoaded', function() {
    var colorSwatchRadios = document.querySelectorAll('.ColorSwatch__Radio');

    // Set the default variant ID in case no color swatch is selected
    if (colorSwatchRadios.length > 0) {
        var defaultVariantUrl = colorSwatchRadios[0].dataset.variantUrl;
        selectedVariantId = extractVariantId(defaultVariantUrl);
    }
    
    colorSwatchRadios.forEach(function(radio) {
        radio.addEventListener('change', function() {
            var variantUrl = this.dataset.variantUrl;
            selectedVariantId = extractVariantId(variantUrl);

            if (selectedVariantId) {
                console.log('Color swatch selection - Variant ID:', selectedVariantId);
            } else {
                console.error('Variant ID not found for the selected color swatch.');
            }
        });
    });
    
    if (colorSwatchRadios.length > 0) {
        colorSwatchRadios[0].checked = true;
    }

    // Check if the cart was updated, and if so, open the cart drawer.
    if (sessionStorage.getItem('cartUpdated') === 'true') {
        openCartDrawer(); // Function to open the cart drawer
        sessionStorage.removeItem('cartUpdated'); // Clear the flag
    }
});

function extractVariantId(variantUrl) {
    var variantIdMatch = variantUrl.match(/variant=(\d+)/) || variantUrl.match(/\/(\d+)$/);
    return variantIdMatch ? variantIdMatch[1] : null;
}

function _addMeToCart(event) {
    event.preventDefault();
    
    if (selectedVariantId) {
        console.log('Adding Variant ID:', selectedVariantId, 'to cart');
        addToCart(selectedVariantId, 1);
    } else {
        console.error('No variant ID selected. Adding the first variant by default.');
    }
}

function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        console.log('Item successfully added to cart:', data);
        sessionStorage.setItem('cartUpdated', 'true'); // Set a flag before reloading
        window.location.reload(); // Reload the page after the item is added to the cart.
    })
    .catch((error) => {
        console.error('Error adding item to cart:', error);
    });
}

function openCartDrawer() {
    // Find the element that opens the cart drawer
    var cartOpener = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    if (cartOpener) {
        cartOpener.click(); // Simulate a click to open the cart drawer
    } else {
        console.error('Cart opener element not found.');
    }
}

// Example function to update the cart UI - implement according to your theme's specifics
function updateCartUI() {
    console.log('Update the cart UI here.');
}
